import axios from 'axios'
import {
    FETCH_BOLSA_SOLICITUD,
    APIpath,
    addToast,
    setRedirect
} from '../actions'

const setSolicitudes = (solicitudes) => ({
    type: FETCH_BOLSA_SOLICITUD,
    solicitudes
})

export const fetchBolsaSolicitud = (id) => (dispatch) => {
    dispatch(setRedirect(false))
    axios.get(`${APIpath}/bolsa-solicitud/${id}/solicitud`)
        .then(function (response) {
            dispatch(setSolicitudes(response.data))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}